import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionIronOverloadCombined from "./index";

const NutritionIronOverloadWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionIronOverloadCombined}
    keyControlsId="nutrition-iron-overload-key"
    {...props}
  />
);

export default NutritionIronOverloadWithToggleKey;
